@import '../../../globals/main.scss';
@import './pn-language-common.scss';
pn-language-selector {
  max-height: 5.2rem;
}
.languageselector {
  position: relative;
}

.languageselector-togglebtn {
  cursor: pointer;
  border: 0;
  padding: 0.64rem 0;
  background-color: $white;
  color: $blue700;
  font-size: 1.6rem;
  &:hover,
  &:focus,
  &:active {
    color: $blue900;
    text-decoration: underline;
  }
  svg {
    width: 1.9rem;
    height: 1.9rem;
  }
}

.languageselector-nav {
}

.languageselector-title {
  padding: 0.8rem 1.6rem;
  display: flex;
  align-items: center;
}

.languageselector-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
